import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useResource } from 'src/hooks/useResource'
import { BackLink } from 'src/components/common'
import { useNotification } from 'src/contexts/notification.context'
import {
  getResourceRequest,
  getResourceQuestionsRequest,
  updateResourceQuestionRequest,
} from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import { toJSON } from 'src/tools'
import QuestionForm from './form'

export const TeacherPracticeQuestion = () => {
  const { id, questionId } = useParams()

  const { showNotificationHelper } = useNotification()
  const history = useHistory()
  const [error, setError] = useState('')

  const [practice, setPractice] = useState(null)
  const [questions, setQuestions] = useState([])

  const [question, setQuestion] = useState(null)
  const [questionIndex, setQuestionIndex] = useState(null)

  const { resourceType, resourceName } = useResource()

  useEffect(() => {
    const fetchAsync = async () => {
      let result = await getResourceRequest(resourceType, id)
      setPractice(result.data?.item)

      result = await getResourceQuestionsRequest(resourceType, id)
      const qs = result.data?.items || []
      setQuestions(qs)
    }
    fetchAsync()
  }, [id])

  useEffect(() => {
    const fetchAsync = async () => {
      const questionIndex = questions.findIndex(
        (x) => Number(x.id) === Number(questionId),
      )
      const question = questionIndex !== null ? questions[questionIndex] : null

      setQuestionIndex(questionIndex)

      // Prepare extra
      console.log('Q', question)
      if (question.extra) {
        try {
          question.extra = toJSON(question.extra) || {}
        } catch (error) {
          console.log(error)
        }
      }

      console.log('Set default problem type')
      console.log(question)

      // Set default problem type
      if (question.problem_type) {
        // question.problem_type = question.problem_type;
        console.log('No change problem_type', question.problem_type)
        console.log(1)
      } else if (questionIndex > 0) {
        question.problem_type = questions[questionIndex - 1].problem_type
        question.answer_type = questions[questionIndex - 1].answer_type
        question.level_id = questions[questionIndex - 1].level_id
        console.log(2)
      } else {
        question.problem_type = 'counting'
        question.answer_type = 'input'
        console.log(3)
      }

      setQuestion(question)
    }

    if (questions.length > 0) {
      fetchAsync()
    }
  }, [questions, id, questionId])

  const onSubmit = async (values) => {
    // try {
    console.log('Prepare values', values)

    let result = await updateResourceQuestionRequest(
      resourceType,
      id,
      questionId,
      { ...values, sort_order: questionIndex },
    )
    result = await getResourceQuestionsRequest(resourceType, id)
    setQuestions(result.data?.items)

    showNotificationHelper({
      title: 'Success',
      body: 'Question updated',
    })

    console.log('questionId', questionId, result.data?.items)

    const currentIdx = result.data?.items.findIndex(
      (x) => Number(x.id) === Number(questionId),
    )

    const next = result.data?.items[currentIdx + 1]

    // console.log('N', currentIdx, next);
    if (next) history.push(routes[resourceType].questions.edit(id, next.id))
    else history.push(routes[resourceType].questions.index(id))
    // } catch(error) {
    //   setError(error.response.data?.error[0]);
    // }
  }

  if (!question) return <div>Loading...</div>

  let order = question?.sort_order
  if (!order) {
    order = questions.findIndex((x) => Number(x.id) === Number(questionId))
  }
  order += 1

  const handleSelectQuestion = (idx) => () => {
    history.push(routes[resourceType].questions.edit(id, questions[idx].id))
  }

  return (
    <>
      <div className="sectionHb-top">
        <BackLink to={routes[resourceType].questions.index(id)} />
        <h2 className="sectionHb-title">
          {practice?.title},{' '}
          <span className="blue__text">Question {order}</span>
        </h2>
      </div>

      <div className="sectionHb-block">
        <div className="sectionHb-block__wrap">
          {/* Content */}
          <div className="letter problem-wrap-view">
            <div className="progress progress-static">
              {new Array(questions.length).fill(1).map((_, i) =>
                questionIndex === i ? (
                  <div
                    key={i}
                    onClick={handleSelectQuestion(i)}
                    className="progress-col current"
                  >
                    {i + 1}/{questions.length}
                  </div>
                ) : (
                  <div
                    key={i}
                    onClick={handleSelectQuestion(i)}
                    className={`progress-col ${
                      questionIndex > i ? 'active' : ''
                    } ${questions[i].extra ? 'success' : ''}`}
                  />
                ),
              )}
            </div>

            <QuestionForm
              practice={practice}
              question={question}
              onSubmit={onSubmit}
              error={error}
            />
          </div>
        </div>
      </div>
    </>
  )
}
